import { createContext, useContext, useState, useEffect, useCallback } from "react";
import API from "../lib/api";
import { useAuth } from "./AuthContext";

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(() => {
    return localStorage.getItem("seointent_selected_client") || "";
  });

  const handleSetSelectedClient = useCallback((id) => {
    setSelectedClientId(id);
    localStorage.setItem("seointent_selected_client", id);
  }, []);

  const loadClients = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const { data } = await API.get("/clients");
      setClients(data);
      const stored = localStorage.getItem("seointent_selected_client");
      if (data.length > 0 && (!selectedClientId || !data.find(c => c._id === selectedClientId))) {
        const fallback = stored && data.find(c => c._id === stored) ? stored : data[0]._id;
        setSelectedClientId(fallback);
        localStorage.setItem("seointent_selected_client", fallback);
      }
    } catch {}
  }, [isAdmin, selectedClientId]);

  useEffect(() => {
    if (isAdmin) loadClients();
  }, [isAdmin, loadClients]);

  // For non-admin users, the client_id is their own user ID
  const activeClientId = isAdmin ? selectedClientId : user?._id || "";
  const activeClient = clients.find(c => c._id === selectedClientId);

  return (
    <ClientContext.Provider value={{
      clients,
      selectedClientId,
      setSelectedClientId: handleSetSelectedClient,
      activeClientId,
      activeClient,
      isAdmin,
      reloadClients: loadClients,
    }}>
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const ctx = useContext(ClientContext);
  if (!ctx) throw new Error("useClient must be used within ClientProvider");
  return ctx;
}
